<template>
  <TextField :label="$tt('hotel_name')" :rules="[required]" />
</template>

<script setup lang="ts">
const { required } = useValidation();
</script>